import Chart from './Chart'
import { formatPercentage } from '../../utils'
import styles from '../styles.module.scss'

const ChartView = ({ surveyResults, chartData }) => (
    <section>
        <h2 className={styles.chartDescription}>{surveyResults?.surveyTexts[0]?.ratingText}</h2>
        <div className={'d-flex'}>
            <Chart chartData={chartData} />
            <div className={styles.chartDetails}>
                <p className={styles.answersDetailsLabel}>
                    <T>nps.admin.dashboard.total.detractors</T>
                </p>
                <p className={styles.answersDetailsNumbers}>{formatPercentage(surveyResults?.detractorsPercentage)}%</p>
                <p className={styles.answersDetailsLabel}>{<T>nps.admin.dashboard.total.passives</T>}</p>
                <p className={styles.answersDetailsNumbers}>{formatPercentage(surveyResults?.passivesPercentage)}%</p>
                <p className={styles.answersDetailsLabel}>{<T>nps.admin.dashboard.total.promoters</T>}</p>
                <p className={styles.answersDetailsNumbers}>{formatPercentage(surveyResults?.promotersPercentage)}%</p>
            </div>
        </div>
    </section>
)

export default ChartView
